<template>
  <div>
    <b-card no-body class="mx-n2 mt-n1 mb-2">
      <ReportsTable @schedule-added="onScheduleAdded"></ReportsTable>
    </b-card>
    <b-card no-body class="mx-n2">
      <ScheduledReportsTable :refreshToken="scheduledReportsRefreshToken"></ScheduledReportsTable>
    </b-card>
  </div>
</template>

<script>
import ReportsTable from '@/xvisor/components/report/ReportsTable.vue';
import ScheduledReportsTable from '@/xvisor/components/report/ScheduledReportsTable.vue';

export default {
  components: {
    ReportsTable,
    ScheduledReportsTable,
  },
  data() {
    return {
      scheduledReportsRefreshToken: 0,
    };
  },
  methods: {
    onScheduleAdded() {
      this.scheduledReportsRefreshToken += 1;
    },
  },
};
</script>
